import { Input } from "../common";
import { formatPrice } from "../../utils/formatPrice";
import { handleKeyPress } from "../../utils/keyboardUtils";
import DollarIcon from "../../assets/icons/dollarIcon.svg";
import { type ChangeEvent, useEffect, useRef } from "react";
import { useUserProfileStore } from "../../stores/profileStore";
import { convertToFormattedAmount } from "../../utils/convertAmount";
import { useAdvertisementUserStore } from "../../stores/advertisementFlowStore";

const MAX_INCOME = 400000;

const IncomeView = () => {
	const { income, setIncome, incomeError } = useAdvertisementUserStore();
	const inputRef = useRef<HTMLInputElement>(null);
	const { userProfile } = useUserProfileStore();

	useEffect(() => {
		if (
			userProfile?.finances?.income &&
			userProfile.finances.income.length > 0
		) {
			const incomeAmount = userProfile.finances.income[0].amount?.amount;
			if (incomeAmount) {
				setIncome(formatPrice(convertToFormattedAmount(incomeAmount)));
			}
		}
	}, [userProfile, setIncome]);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		let value = Number.parseInt(e.target.value.replace(/[^\d]/g, ""));
		if (Number.isNaN(value)) {
			value = 0;
		}
		if (value > MAX_INCOME) {
			value = MAX_INCOME;
		}
		setIncome(formatPrice(value));
	};
	return (
		<div
			className="space-y-8 px-4 w-full"
			onKeyDown={(e) => handleKeyPress(e, inputRef)}
		>
			<h3 className="text-3xl font-bold">
				Enter your{" "}
				<span className="text-z-dark-moss-green">
					annual
					<br /> household income
				</span>
			</h3>
			<div className="text-z-dark-moss-green font-semibold">(before tax)</div>
			<Input
				inputType="tel"
				ref={inputRef}
				value={income}
				onChange={handleChange}
				isError={incomeError}
				startIcon={DollarIcon}
				radius="20px"
				label="Annual Household Income"
			/>
		</div>
	);
};

export { IncomeView };
